export const ORDER_STATUS_TEXT = {
    APPROVING: 'Chờ xác nhận',
    APPROVED: 'Đã xác nhận',
    FAIL: 'Đã hủy',
    SUCCESS: 'Thành công',
}